import getLogger from './getLogger';

const coreLogger = getLogger({ namespace: 'Core' });

/**
 * @component
 * @visibleName coreLogger
 */
export default coreLogger;
